"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MeetingSearchServiceQueryParams", {
    enumerable: true,
    get: function() {
        return MeetingSearchServiceQueryParams;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _base = require("../../base");
const MeetingSearchServiceQueryParams = _base.BaseSearchServiceQueryParams.extend({
    service: _zod.z.literal("meeting"),
    // Meeting details page filters
    meeting_workspace_id_eq: _utilsisomorphic.transformObjectId.optional(),
    recurring_series_id_eq: _utilsisomorphic.transformObjectId.optional(),
    // Company meetings page filters
    is_company_meetings_request: _zod.z.string().optional(),
    participant_id_eq: _utilsisomorphic.transformObjectId.optional(),
    start_date_time_gte: _utilsisomorphic.transformDate.optional(),
    start_date_time_lte: _utilsisomorphic.transformDate.optional(),
    name_re: _zod.z.string().optional(),
    status_in: _zod.z.string().optional(),
    private_notes_filter_eq: _zod.z.string().optional()
});
